import React from 'react';

const Logo = () => {
	return <img className="logo" src="/images/ui/logo.svg" alt="UK Police Memorial" />
}

export default Logo;